import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from 'src/components/Octopath/layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Menu = makeShortcode("Menu");
const Battle = makeShortcode("Battle");
const layoutProps = {
  _frontmatter
};

const MDXLayout = ({
  children
}) => <Layout>{children}</Layout>;

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Osvald Single Story" mdxType="SEO" />
    <h1 {...{
      "id": "osvald-single-story"
    }}>{`Osvald Single Story`}</h1>
    <p>{`Based on route/notes by Dalia & Alta. I made improvements to money / stone routing and improved the Warden Davids fight, but the core of the route is the same.`}</p>
    <p>{`There is a lot of small variations/choices based on what resources you have. I will try my best to list them, but can't guarantee I'll cover all of them.`}</p>
    <h2 {...{
      "id": "route"
    }}>{`Route`}</h2>
    <p>{`Start Osvald`}</p>
    <h3 {...{
      "id": "chapter-1"
    }}>{`Chapter 1`}</h3>
    <p>{`Scrutinize Emerald, Option 2`}<br parentName="p"></br>{`
`}{`Talk to Bale, Scrutinize guy north of Save Point, talk to Bale.`}<br parentName="p"></br>{`
`}{`Scrutinize closest guy on 2nd floor in Prison, pick up Labor Reports in Library.`}</p>
    <p>{`Kill all encounters until 30JP.`}</p>
    <p>{`Pick `}<strong parentName="p">{`Sinner's Staff`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Ancient Necklace`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "items"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`Ancient Necklace: Osvald`}</li>
        <li parentName="ul">{`Sinner's Rod: Osvald`}</li>
      </ul>
    </Menu>
    <p>{`After 30JP, menu.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "items-1"
      }}>{`Items`}</h5>
      <p>{`Heal Osvald HP/SP if needed.`}</p>
      <h5 {...{
        "id": "learn-skills"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Advanced Magic`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <blockquote>
        <p parentName="blockquote">{`You need a total of 3 Advanced Magics and 2 Plums on Osvald.`}<br parentName="p"></br>{`
`}{`You can replace 1st Emerald Defend in favor of healing, and even have Osvald Defend T3. Fight is fairly flexible in when you do your heals and Advanced Magics.`}<br parentName="p"></br>{`
`}{`If you got a Ice S, there is a better fight available. Saves about 10 seconds, will be in the Addendum.`}</p>
      </blockquote>
      <h4 {...{
        "id": "warden-davids-2700hp-5s"
      }}>{`Warden Davids 2700HP 5S`}</h4>
      <h5 {...{
        "id": "turn-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Advanced Magic`}</li>
        <li parentName="ul">{`Emerald: Attack`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Advanced Magic`}</li>
        <li parentName="ul">{`Emerald: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Emerald: Attack x4`}</li>
        <li parentName="ul">{`Osvald: Blizzard x2`}</li>
      </ul>
      <h5 {...{
        "id": "turn-4"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Advanced Magic / Plum`}</li>
        <li parentName="ul">{`Emerald: Grape / Plum`}</li>
      </ul>
      <h5 {...{
        "id": "turn-5"
      }}>{`Turn 5`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Advanced Magic`}</li>
        <li parentName="ul">{`Emerald: Attack`}</li>
      </ul>
      <h5 {...{
        "id": "turn-6"
      }}>{`Turn 6`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Grape`}</li>
        <li parentName="ul">{`Emerald: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-7"
      }}>{`Turn 7`}</h5>
      <ul>
        <li parentName="ul">{`Emerald: Attack x4`}</li>
        <li parentName="ul">{`Osvald: Blizzard x4`}</li>
      </ul>
      <h5 {...{
        "id": "turn-8"
      }}>{`Turn 8`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Firestorm`}</li>
        <li parentName="ul">{`Emerald: Plum`}</li>
      </ul>
      <h5 {...{
        "id": "turn-9"
      }}>{`Turn 9`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Firestorm`}</li>
      </ul>
      <h5 {...{
        "id": "turn-10"
      }}>{`Turn 10`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-11"
      }}>{`Turn 11`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Attack x3`}</li>
      </ul>
      <h5 {...{
        "id": "turn-12"
      }}>{`Turn 12`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: LP Firestorm x4`}</li>
        <li parentName="ul">{`Emerald: Attack x3`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "chapter-2"
    }}>{`Chapter 2`}</h3>
    <p>{`Walk till 1st cutscene.`}<br parentName="p"></br>{`
`}{`Can kill Wolf with Defend + Attack, Fireball x3 + Attack x2`}</p>
    <p>{`Guards: Emerald attack each once, Osvald Advanced Magic, Defend, Blizzard x4`}</p>
    <h3 {...{
      "id": "cape-cold"
    }}>{`Cape Cold`}</h3>
    <p>{`Mug Old Man, Staff + Fireball x3 or LP Icewind x2 (range)`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`1 Fire S`}</li>
        <li parentName="ul">{`1 Thunder S`}</li>
        <li parentName="ul">{`2 Fire M`}</li>
        <li parentName="ul">{`4 Light M`}</li>
      </ul>
    </Menu>
    <blockquote>
      <p parentName="blockquote">{`Usage of your Light Ms is fairly flexible. In the notes, they will be used on Throne recruitment, Canalbrine battle, and 2 on 1 Crackridge battle. If you need to save one, you can break the Armor Eater on Crackridge battle and use 1 Light M instead. Alternate uses are Caits/Puffs, and Temenos recruitment.`}</p>
    </blockquote>
    <p>{`Tag `}<strong parentName="p">{`New Delsta: Anchorage`}</strong>{`. Go to `}<strong parentName="p">{`New Delsta`}</strong>{`.`}</p>
    <h3 {...{
      "id": "new-delsta"
    }}>{`New Delsta`}</h3>
    <p>{`Throne Recruitment: Light M`}</p>
    <blockquote>
      <p parentName="blockquote">{`Watch your JP. If you have >90JP, you'll want to take a Canalbrine day battle. These can often be cleared with S Stones. They don't have much use outside of this spot though.`}</p>
    </blockquote>
    <p>{`If no Ice S, Steal Ice S. Optionally steal other stones.`}</p>
    <p>{`Buy `}<strong parentName="p">{`Unerring Earring`}</strong><br parentName="p"></br>{`
`}{`Buy `}<strong parentName="p">{`Forget-me-do`}</strong>{`. `}<em parentName="p">{`If no Grapes, buy 1 for Castti recruitment.`}</em></p>
    <p>{`TP `}<strong parentName="p">{`New Delsta Anchorage`}</strong></p>
    <h3 {...{
      "id": "new-delsta-anchorage"
    }}>{`New Delsta Anchorage`}</h3>
    <p>{`Take boat to `}<strong parentName="p">{`Beasting Bay: Anchorage`}</strong></p>
    <h3 {...{
      "id": "beasting-bay-anchorage"
    }}>{`Beasting Bay: Anchorage`}</h3>
    <p>{`Take boat to `}<strong parentName="p">{`Canalbrine`}</strong>{`.`}</p>
    <h3 {...{
      "id": "canalbrine"
    }}>{`Canalbrine`}</h3>
    <p>{`Recruit `}<strong parentName="p">{`Castti`}</strong><br parentName="p"></br>{`
`}{`Buy `}<strong parentName="p">{`Critical Earring`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Head to `}<strong parentName="p">{`Conning Creek`}</strong>{`.`}</p>
    <p>{`1st Bridge Battle switch to night and kill it with Light M.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If it'll get you enough JP, day time battle guarantees Throne LVL8. There's one Night Battle (Ocean Lizardman II) that will leave her 2XP short.`}</p>
    </blockquote>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "skills"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: +Elemental Barrage`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: +Evasive Maneuvers`}</li>
      </ul>
    </Menu>
    <p>{`Kill both Conning Creek battles during day with `}<strong parentName="p">{`Fire M`}</strong>{`.`}</p>
    <p>{`Steal `}<strong parentName="p">{`Pom Leaf`}</strong>{`.`}</p>
    <h3 {...{
      "id": "conning-creek"
    }}>{`Conning Creek`}</h3>
    <p>{`Start Osvald Ch.3`}<br parentName="p"></br>{`
`}{`Steal `}<strong parentName="p">{`Pom M, Wind L`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If you fail these steals and run out of reputation, there are backups.`}<br parentName="p"></br>{`
`}{`Pom M: Steal in top floor right side of Montwise Library. 80% Steal.`}<br parentName="p"></br>{`
`}{`Wind L: Break the Armor Eater for both Crackridge battles and use 1 Light M on each.`}<br parentName="p"></br>{`
`}{`You can also just reload the autosave and try again.`}</p>
    </blockquote>
    <p>{`TP `}<strong parentName="p">{`New Delsta`}</strong>{`.`}</p>
    <h3 {...{
      "id": "new-delsta-1"
    }}>{`New Delsta`}</h3>
    <p>{`Get `}<strong parentName="p">{`Inventor`}</strong>{` + upgrades.`}<br parentName="p"></br>{`
`}{`Go to `}<strong parentName="p">{`Flameschurch`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If you didn't get the Wind L, you will want to break + Light M both Crackridge encounters.`}<br parentName="p"></br>{`
`}{`I recommend equipping A Step Ahead on everyone here in that case, it will get you extra escape chances onn the 2 following small battles.`}</p>
    </blockquote>
    <h3 {...{
      "id": "flameschurch"
    }}>{`Flameschurch`}</h3>
    <p>{`Recruit `}<strong parentName="p">{`Temenos`}</strong>{`.`}</p>
    <p>{`Fight: Light M if not used on Bridge, else `}<strong parentName="p">{`Night`}</strong>{` LP Fireball x2 + 2 Attacks, or Fireball x2 + Dagger x2 + Axe x2 after break.`}</p>
    <p>{`TP `}<strong parentName="p">{`New Delsta: Anchorage`}</strong>{`.`}</p>
    <h3 {...{
      "id": "new-delsta-anchorage-1"
    }}>{`New Delsta: Anchorage`}</h3>
    <p>{`Take boat to `}<strong parentName="p">{`Crackridge: Anchorage`}</strong>{`.`}</p>
    <h3 {...{
      "id": "crackridge-anchorage"
    }}>{`Crackridge: Anchorage`}</h3>
    <p>{`Run from battle.`}</p>
    <p>{`Crackridge battles: can choose to take at night for Blind safety. Kill with 2 Light M, or Wind L.`}</p>
    <p>{`Pick `}<strong parentName="p">{`$6400`}</strong>{` on the 1st screen. You might want to walk a bit on this screen, there is a chance of a double battle.`}</p>
    <p>{`2nd screen pick `}<strong parentName="p">{`Thunder M`}</strong>{`. Get `}<strong parentName="p">{`Merchant Guild`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`If you have enough JP from Caits/Puffs, can teach Throne Collect here as well. In that case, giver her Boost Start, and don't bother giving Castti A Step Ahead. You can then skip the next menu.`}</p>
      </blockquote>
      <h5 {...{
        "id": "jobs"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Merchant, +Donate BP +Hired Help`}</li>
        <li parentName="ul">{`Castti: Inventor`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-1"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Throne: +Grow on Trees +A Step Ahead`}</li>
        <li parentName="ul">{`Castti: +A Step Ahead`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "western-gravell-wilds"
    }}>{`Western Gravell Wilds`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Thunder L`}</strong>{`. Switch to night right after.`}</p>
    <p>{`Gravell battle: Castti Thunder M + Throne Defend > Throne HHG x3`}</p>
    <blockquote>
      <p parentName="blockquote">{`Watch drops here. If you get a Pom Leaf, you can use that on Grieving Golem instead of a Pom S/L Stone.`}</p>
    </blockquote>
    <p>{`Tag `}<strong parentName="p">{`Gravell`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$23000`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Conning Creek`}</strong>{`.`}</p>
    <h3 {...{
      "id": "conning-creek-1"
    }}>{`Conning Creek`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Fire M`}</strong>{`. Switch to night before fight.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "lady-clarissa-8212hp-5s"
      }}>{`Lady Clarissa 8212HP 5S`}</h4>
      <p>{`Crit Scope + Defend, HHG x3`}</p>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Flameschurch`}</strong>{`, head to `}<strong parentName="p">{`Montwise`}</strong>{`.`}</p>
    <h3 {...{
      "id": "borderfall"
    }}>{`Borderfall`}</h3>
    <p>{`Kill battle with Fire M. `}<em parentName="p">{`Can try to Flee and use Fire M on Guards in Guard Outpost`}</em></p>
    <p>{`Pick `}<strong parentName="p">{`Thunder M`}</strong>{`.`}</p>
    <h3 {...{
      "id": "montwise"
    }}>{`Montwise`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "learn-skills-1"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Throne: +Collect`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-2"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Throne: +Boost Start`}</li>
        <li parentName="ul">{`Castti: -A Step Ahead`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Conning Creek`}</strong>{`.`}</p>
    <h3 {...{
      "id": "conning-creek-2"
    }}>{`Conning Creek`}</h3>
    <p>{`Talk to NPCs, go to `}<strong parentName="p">{`Guard Outpost`}</strong>{`.`}</p>
    <h3 {...{
      "id": "guard-outpost"
    }}>{`Guard Outpost`}</h3>
    <p>{`Break battle with HHMx2 and Flee (or Fire M).`}<br parentName="p"></br>{`
`}{`Switch to Night before fight.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "captain-stenvar-19000hp-5s"
      }}>{`Captain Stenvar 19000HP 5S`}</h4>
      <p>{`Defend > HHB x4`}</p>
    </Battle>
    <p>{`If you need Latent on Castti, you can stay at inn here and then steal `}<strong parentName="p">{`Pom S`}</strong>{` in Inn to save a L Stone on Grieving Golem.`}</p>
    <p>{`TP `}<strong parentName="p">{`Montwise`}</strong>{`.`}</p>
    <h3 {...{
      "id": "montwise-1"
    }}>{`Montwise`}</h3>
    <p>{`Steal `}<strong parentName="p">{`Dazzling Artwork (55%)`}</strong>{`. If no M Stones, Steal at least one.`}<br parentName="p"></br>{`
`}{`If no Pom M, Steal one from NPC in library top floor right side.`}</p>
    <p>{`Pick `}<strong parentName="p">{`$14000`}</strong>{`. Reset steps with Travel Banter.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Fire L`}</strong>{`. `}<em parentName="p">{`Can skip if you have a Pom and a Thunder L`}</em></p>
    <p>{`Switch to night before fight.`}</p>
    <p>{`Fight: HHG x3`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-1"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Merchant, +Collect +Ember +Hired Help`}</li>
        <li parentName="ul">{`Throne: Merchant`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-3"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: +A Step Ahead +Grow on Trees +Boost Start`}</li>
        <li parentName="ul">{`Temenos: +A Step Ahead`}</li>
        <li parentName="ul">{`Castti: +A Step Ahead`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "grieving-golem-62000hp-7s-spear-staff-wind-light"
      }}>{`Grieving Golem 62000HP 7S (Spear, Staff, Wind, Light)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`Can be done with either HHG x3 or x4. If x4, throw an extra L Stone. x3 requires a Pom S on Throne.`}<br parentName="p"></br>{`
`}{`M Stone can be replaced with Catapult x4 if you give Castti Axe of Avarice`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Defend`}</li>
        <li parentName="ul">{`Throne: Pom M Self`}</li>
        <li parentName="ul">{`Castti: Crit Scope`}</li>
        <li parentName="ul">{`Temenos: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-1"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Attack x4`}</li>
        <li parentName="ul">{`Temenos: Attack x3`}</li>
        <li parentName="ul">{`Throne: HHB x4`}</li>
        <li parentName="ul">{`Castti: L Stone / Pom S / Defend and Pom S next turn.`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-1"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Throne: HHG x3`}</li>
        <li parentName="ul">{`Someone: M Stone`}</li>
      </ul>
    </Battle>
    <p>{`Go to Item Shop.`}</p>
    <Menu mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`Need 38446, 38598 if you need Inn`}</p>
      </blockquote>
      <h5 {...{
        "id": "sell"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Dazzling Artwork`}</li>
        <li parentName="ul">{`Axe of Avarice`}</li>
        <li parentName="ul">{`Olive L if needed. `}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`If you got Cait/Puff money, can sell Olive L and get a HHG for the 1st Duskruin screen.`}</p>
      </blockquote>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Gravell`}</strong>{`.`}</p>
    <h3 {...{
      "id": "gravell"
    }}>{`Gravell`}</h3>
    <p>{`If Throne or Castti no Latent, stay at inn.`}<br parentName="p"></br>{`
`}{`Steal `}<strong parentName="p">{`Light M & Shadow M`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`Can optionally give Osvald Lightning Bolt in this menu. Can be used on Mug 2 and to help clear the bird battle in Duskruin.`}</p>
      </blockquote>
      <h5 {...{
        "id": "jobs-2"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Merchant`}</li>
        <li parentName="ul">{`Temenos: Inventor`}</li>
      </ul>
    </Menu>
    <p>{`Mug 1: Attack, HHG x4, M Stone if alive.`}<br parentName="p"></br>{`
`}{`Mug 2: E.Barrage till break, HHG x4. Works with HHG x3 too, so can do E.Barrage x2 T2`}<br parentName="p"></br>{`
`}{`Mug 3: Attack, HHG x4, M Stone`}<br parentName="p"></br>{`
`}{`Mug 4: HHG x3`}<br parentName="p"></br>{`
`}{`Mug 5: Defend, HHB x4, M Stone if alive.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-3"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Merchant`}</li>
      </ul>
    </Menu>
    <p>{`If on money route, you should have one HHG you can use here to clear a battle. After the chest, you also have a HHB, but you would have to play for the range on Harvey.`}</p>
    <p>{`If no Fire / Thunder L, pick `}<strong parentName="p">{`Ice L`}</strong>{`.`}</p>
    <h4 {...{
      "id": "clears"
    }}>{`Clears`}</h4>
    <ul>
      <li parentName="ul">{`Revenant: Sword, Staff`}</li>
      <li parentName="ul">{`2 Remnants x3: HHM x3 OR Sword, Spear, Axe`}</li>
      <li parentName="ul">{`5 Bats: Shadow L to kill.`}</li>
      <li parentName="ul">{`Moleking + 2 Remnants: HHM x3, Temenos Sword Moleking`}</li>
      <li parentName="ul">{`Revenant + Remnant: HHM x3, Staffs on Revenant`}</li>
      <li parentName="ul">{`Fledgling + 2 Dreadwing: Osvald Attack x2 Fledling T2, Throne does a 2 Spear T1 and a 2 Spear T2, Temmy Catapults Spear. Can also be done with HHG x4 + Stone during day, or HHG x4 during night. Also can Advanced Magic Lightning Bolt, but still need 1 more hit on each Dreadwing.`}</li>
      <li parentName="ul">{`2 Moleking: Axe, Staff, Ice: Osvald Attack x3, Castti Attack x2, Temenos Attack x2, Throne Donate BP whoever is 1st T2.`}</li>
    </ul>
    <p>{`Pick `}<strong parentName="p">{`$25000`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`There's a `}<strong parentName="p">{`Lychee L`}</strong>{` on second screen, not the safest pickup.`}</p>
    </blockquote>
    <p>{`Switch to night before forced fights (before stairs)`}</p>
    <h4 {...{
      "id": "remnants"
    }}>{`Remnants`}</h4>
    <ul>
      <li parentName="ul">{`HHB x4`}</li>
    </ul>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "harvey-80000hp-10s-spear-axe-fire-ice-lightning"
      }}>{`Harvey 80000HP 10S (Spear, Axe, Fire, Ice, Lightning)`}</h4>
      <h5 {...{
        "id": "turn-1-2"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Elemental Barrage`}</li>
        <li parentName="ul">{`Throne: Fire/Ice/Thunder L (Can use Shadow and gamble on E.Barrage hits)`}</li>
        <li parentName="ul">{`Castti: Concoct Forget-me-do + Anything`}</li>
        <li parentName="ul">{`Temenos: Springy Boots Osvald`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`If Temenos before Throne, can HHB x4 T2 and Collect x4 > HHV x3 for 100% Collect.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-2-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Elemental Barrage x4`}</li>
        <li parentName="ul">{`Throne: Collect x4`}</li>
        <li parentName="ul">{`Castti: Defend`}</li>
        <li parentName="ul">{`Temenos: Critical Scope`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-2"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Castti: `}{`[LP]`}{` Pom Leaf x5 Throne`}</li>
        <li parentName="ul">{`Throne: `}{`[LP]`}{` HHB x4, HHV x3`}</li>
        <li parentName="ul">{`Osvald & Temenos: Shadow L`}</li>
      </ul>
    </Battle>
    <p>{`Scrutinize Elena. GG!`}</p>
    <h3 {...{
      "id": "addendum"
    }}>{`Addendum`}</h3>
    <h4 {...{
      "id": "ice-s-warden-davids-fight"
    }}>{`Ice S Warden Davids Fight`}</h4>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "warden-davids-2700hp-5s-1"
      }}>{`Warden Davids 2700HP 5S`}</h4>
      <h5 {...{
        "id": "turn-1-3"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Advanced Magic`}</li>
        <li parentName="ul">{`Emerald: Attack x2`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-3"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Advanced Magic`}</li>
        <li parentName="ul">{`Emerald: Plum Osvald (56/71SP needed depending on if Osvald was before or after Emerald)`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Firestorm`}</li>
        <li parentName="ul">{`Emerald: Grape`}</li>
      </ul>
      <h5 {...{
        "id": "turn-4-1"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Grape`}</li>
        <li parentName="ul">{`Emerald: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-5-1"
      }}>{`Turn 5`}</h5>
      <ul>
        <li parentName="ul">{`Emerald: Attack x4`}</li>
        <li parentName="ul">{`Osvald: Blizzard x4`}</li>
      </ul>
      <h5 {...{
        "id": "turn-6-1"
      }}>{`Turn 6`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Ice S`}</li>
        <li parentName="ul">{`Emerald: Grape`}</li>
      </ul>
      <h5 {...{
        "id": "turn-7-1"
      }}>{`Turn 7`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Firestorm`}</li>
      </ul>
      <h5 {...{
        "id": "turn-8-1"
      }}>{`Turn 8`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-9-1"
      }}>{`Turn 9`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Attack x3`}</li>
      </ul>
      <h5 {...{
        "id": "turn-10-1"
      }}>{`Turn 10`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: LP Firestorm x4`}</li>
        <li parentName="ul">{`Emerald: Attack x4`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "changelog"
    }}>{`Changelog`}</h3>
    <h4 {...{
      "id": "22424"
    }}>{`2/24/24`}</h4>
    <ul>
      <li parentName="ul">{`Remove You`}</li>
    </ul>
    <h4 {...{
      "id": "22124"
    }}>{`2/21/24`}</h4>
    <ul>
      <li parentName="ul">{`Initial Upload`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      